export interface AddressResource {
  addressLine: string;
  addressLine2: string;
  postcode: string;
  city: string;
  countryCode: string | null;
}

export interface AddressParts {
  addressLine: string;
  addressLine2: string;
  postcode: string;
  city: string;
}

export const ADDRESS_PART_FIELDS: ReadonlyArray<keyof AddressParts> = [
  "addressLine",
  "addressLine2",
  "postcode",
  "city",
];

export const addressPartsFromResource = (
  address: AddressResource | null | undefined
): AddressParts => ({
  addressLine: address?.addressLine ?? "",
  addressLine2: address?.addressLine2 ?? "",
  postcode: address?.postcode ?? "",
  city: address?.city ?? "",
});

export const addressPartsFromFormValues = (
  values: Partial<Record<keyof AddressParts, string | null>>
): AddressParts => ({
  addressLine: values.addressLine ?? "",
  addressLine2: values.addressLine2 ?? "",
  postcode: values.postcode ?? "",
  city: values.city ?? "",
});
